export default __webpack_public_path__ + "static/media/metacheckPilot.2acd2de4.png";